// Minimálna dĺžka nového hesla – rovnaké pravidlo ako backend/services/passwordPolicy.js
export const PASSWORD_MIN_LENGTH = 8;

export const PASSWORD_MIN_LENGTH_MESSAGE = `Heslo musí mať aspoň ${PASSWORD_MIN_LENGTH} znakov.`;
